import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { AnalyticsService } from '@core/services/analytics/analytics.service';

export const analyticsResolver: ResolveFn<void> = (route: ActivatedRouteSnapshot) => {
  if (window.gtag == null) {
    return;
  }
  const analytics = inject(AnalyticsService);
  const { screenName, screenSubName } = route.data.analyticsParams;
  analytics.screen_view(screenName, screenSubName);
};
